<template>
  <v-container>
    <div>
      <template>
        <v-dialog v-model="dialog" width="609" @click:outside="closeModal">
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold"
                >Download Confirmation</v-toolbar-title
              >

              <v-spacer></v-spacer>

              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <form autocomplete="off">
              <v-card-text class="black--text">
                <div class="title" for="name">
                  Please choose option to download as pdf.
                </div>
                <v-radio-group v-model="column" column>
                  <v-radio
                    :label="getCurrentRecord()"
                    value="current-page"
                  ></v-radio>
                  <v-radio :label="getAllRecords()" value="all"></v-radio>
                </v-radio-group>
                <v-divider style=""></v-divider>
                <v-card-actions class="mt-10">
                  <v-spacer></v-spacer>
                  <v-btn
                    class=""
                    outlined
                    color="primary"
                    @click="closeModal"
                    width="112"
                  >
                    {{ $t("cancel") }}
                  </v-btn>
                  <v-btn
                    @click="downloadConfirmation()"
                    width="112"
                    color="primary"
                    class="btn-11 btn-22"
                  >
                    Submit
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </form>
          </v-card>
        </v-dialog>
      </template>
    </div>
  </v-container>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
export default {
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  data() {
    return {
      column: "singleEquipment",
    };
  },
  props: {
    currentRecord: {
      type: Number,
      required: true,
    },
    totalRecords: {
      type: Number,
      required: true,
    },
    dialogI: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("closePdfConfirmation");
    },
    async downloadConfirmation() {
      this.$emit("exportToPdf", this.column);
    },
    getAllRecords() {
      return `All pages (${this.totalRecords} records)`;
    },
    getCurrentRecord() {
      return `Only current page (${this.currentRecord} records)`;
    },
  },

  mixins: [loadingMixin],
};
</script>
